
// @ts-nocheck


export const localeCodes =  [
  "zh",
  "zh-TW",
  "en",
  "ja",
  "ko",
  "fr",
  "de",
  "es"
]

export const localeLoaders = {
  zh: [
    {
      key: "locale_zh_46json_cca0d698",
      load: () => import("#nuxt-i18n/cca0d698" /* webpackChunkName: "locale_zh_46json_cca0d698" */),
      cache: true
    }
  ],
  "zh-TW": [
    {
      key: "locale_zh_45TW_46json_0317a59a",
      load: () => import("#nuxt-i18n/0317a59a" /* webpackChunkName: "locale_zh_45TW_46json_0317a59a" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_76ef8785",
      load: () => import("#nuxt-i18n/76ef8785" /* webpackChunkName: "locale_en_46json_76ef8785" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_237a0611",
      load: () => import("#nuxt-i18n/237a0611" /* webpackChunkName: "locale_ja_46json_237a0611" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_278aeb17",
      load: () => import("#nuxt-i18n/278aeb17" /* webpackChunkName: "locale_ko_46json_278aeb17" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_0b687afd",
      load: () => import("#nuxt-i18n/0b687afd" /* webpackChunkName: "locale_fr_46json_0b687afd" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_96bd13ad",
      load: () => import("#nuxt-i18n/96bd13ad" /* webpackChunkName: "locale_de_46json_96bd13ad" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_4ecbb65f",
      load: () => import("#nuxt-i18n/4ecbb65f" /* webpackChunkName: "locale_es_46json_4ecbb65f" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/db048695" /* webpackChunkName: "config_i18n_46config_46ts_db048695" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "zh",
      name: "简体中文",
      files: [
        {
          path: "/vercel/path0/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh-TW",
      name: "繁體中文",
      files: [
        {
          path: "/vercel/path0/i18n/locales/zh-TW.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/vercel/path0/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "日本語",
      files: [
        {
          path: "/vercel/path0/i18n/locales/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "한국어",
      files: [
        {
          path: "/vercel/path0/i18n/locales/ko.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/vercel/path0/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/vercel/path0/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      files: [
        {
          path: "/vercel/path0/i18n/locales/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "zh",
    name: "简体中文",
    files: [
      {
        path: "/vercel/path0/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-TW",
    name: "繁體中文",
    files: [
      {
        path: "/vercel/path0/i18n/locales/zh-TW.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/vercel/path0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "日本語",
    files: [
      {
        path: "/vercel/path0/i18n/locales/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "한국어",
    files: [
      {
        path: "/vercel/path0/i18n/locales/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/vercel/path0/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/vercel/path0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    files: [
      {
        path: "/vercel/path0/i18n/locales/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/